import type { InputHTMLAttributes } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface FieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "onChange" | "value"> {
  readonly id: string;
  readonly label: string;
  readonly value: string;
  readonly onValue: (value: string) => void;
}

/** Campo rotulado das telas de credencial (label + input controlado). */
export function Field({ id, label, value, onValue, ...inputProps }: FieldProps): JSX.Element {
  return (
    <div className="space-y-2">
      <Label htmlFor={id} variant="field">{label}</Label>
      <Input id={id} value={value} onChange={(event) => onValue(event.target.value)} autoComplete="off" {...inputProps} />
    </div>
  );
}
